module.exports = __webpack_public_path__ + "static/media/paypal-donate.170ad0e3.png";